export enum EbillsImportRedirectStateEntryPoint {
  Onboarding = 'onboarding',
  Settings = 'settings',
}
export type EbillsImportRedirectState = { provider: string; entryPoint?: EbillsImportRedirectStateEntryPoint };
